import {
  Clipboard,
  Image,
  Modal,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { FlatList } from "react-native-gesture-handler";
import { toast } from "react-toastify";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppImages } from "../utility/AppImages";
import Separator from "./Separator";
import CustomProgressBar from "../common/CustomProgressBar";
import { getReferral } from "../services/authAPI";
import { ShowLoader } from "../common/ShowLoader";
import { urls, dynamicWebUrl } from "../Api/configs";

export default function ReferAndEarn(props) {
  const {
    showModal = false,
    setShowModal,
    links,
    referralCode,
    callUpdateReferralCodeAPI,
    accessToken,
  } = props;
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [referralCount, setReferralCount] = useState(0);
  const [loader, setLoader] = useState(false);
  // Calculate adjusted referral count for display (resets to 1 after every 5)
  const adjustedReferralCount =
    referralCount === 0 ? 0 : referralCount % 5 || 5;
  async function getReferralData(accessToken) {
    setLoader(true);
    try {
      const param = {
        accessToken,
      };
      const data = await getReferral(param);
      const parsedBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      const referralData = parsedBody.referredUsers;
      if (referralData.length > 0) {
        setReferralCount(referralData.length);
      }
    } catch (error) {
      console.error("Error fetching referral data:", error);
    } finally {
      setLoader(false);
    }
  }

  const generateRandomString = (length = 9) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomString = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters[randomIndex];
    }

    return randomString;
  };

  let generatedReferralCode;
  if (!referralCode) {
    generatedReferralCode = generateRandomString();
    callUpdateReferralCodeAPI(generatedReferralCode);
  }

  const handleCopyLink = () => {
    if (referralCount < 100) {
      Clipboard.setString(referralCode ? referralCode : generatedReferralCode);
      toast.success("Referral Code copied to clipboard!");
      setShowModal(false);
    } else {
      toast.error("You have already Referred 100 Users!");
    }
  };

  const onCloseClick = () => {
    setShowModal(false);
  };

  const socialMediaOptions = [
    {
      id: 0,
      name: "Instagram",
      image: AppImages.icSocialInsta,
      link: links?.instagram
        ? links.instagram
        : "https://www.instagram.com/accounts/login/?hl=en",
    },
    {
      id: 1,
      name: "Whatsapp",
      image: AppImages.icSocialWhatsapp,
      link: "",
    },
    {
      id: 2,
      name: "X",
      image: AppImages.icSocialX,
      link: links.x ? links.x : "",
    },
    {
      id: 3,
      name: "Snapchat",
      image: AppImages.icSocialSnapChat,
      link: "",
    },
    {
      id: 4,
      name: "Tiktok",
      image: AppImages.icSocialTiktok,
      link: "",
    },
    links.facebook && {
      id: 5,
      name: "Facebook",
      image: AppImages.icSocialFacebook,
      link: links?.facebook ? links.facebook : "",
    },
  ].filter(Boolean);

  const shareOnPlatform = (platform, link) => {
    const baseUrl = `${dynamicWebUrl}/signup`;
    const referralParam = referralCode ? `?referralCode=${referralCode}` : "";
    const fullUrl = `${baseUrl}${referralParam}`;

    let shareUrl = "";

    switch (platform) {
      case "Whatsapp":
        shareUrl = `https://wa.me/?text=${encodeURIComponent(fullUrl)}`;
        break;
      case "Instagram":
        shareUrl = `instagram://sharesheet?text=${encodeURIComponent(fullUrl)}`;
        break;
      case "X":
        shareUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "Facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "Snapchat":
        shareUrl = `https://www.snapchat.com/share?url=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      case "Tiktok":
        shareUrl = `https://www.tiktok.com/share?url=${encodeURIComponent(
          fullUrl
        )}`;
        break;
      default:
        shareUrl = fullUrl;
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  };

  useEffect(() => {
    getReferralData(accessToken);
  }, []);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.MEDIUM_ANYBODY_14
                  : AppFontStyle.MEDIUM_ANYBODY_24,
                {},
              ]}
            >
              Refer and Earn Rewards
            </Text>
            <TouchableOpacity
              onPress={onCloseClick}
              activeOpacity={0.5}
              style={{
                padding: 7,
                backgroundColor: AppColors.gray_212222,
                borderWidth: 1,
                borderColor: AppColors.grayColor_393939,
                borderRadius: 6,
              }}
            >
              <Image
                source={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? AppFontStyle.MEDIUM_ANYBODY_12
                : AppFontStyle.MEDIUM_ANYBODY_18,
              { marginTop: 12 },
            ]}
          >
            Invite friends and earn rewards when they join using your code.
          </Text>
          <View>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.SEMIBOLD_ANYBODY_18
                  : AppFontStyle.SEMIBOLD_ANYBODY_28,
                { textAlign: "center", marginVertical: 22 },
              ]}
            >
              1 Referral = 65 Tokens
            </Text>
          </View>
          <View
            style={{ flexDirection: "row", gap: 12, alignItems: "flex-end" }}
          >
            <View style={{ flex: 1, gap: 6 }}>
              <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>Referral code</Text>
              <TextInput
                multiline={false}
                placeholderTextColor={AppColors.gray_C3C3C3}
                style={[AppFontStyle.REGULAR_ANYBODY_14, styles.textInputStyle]}
                keyboardType="default"
                secureTextEntry={false}
                value={referralCode ? referralCode : generatedReferralCode}
                aria-disabled={true}
              />
            </View>
            <View>
              <TouchableOpacity
                style={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  borderRadius: 8,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  opacity: referralCount >= 100 ? 0.5 : 1,
                }}
                disabled={referralCount >= 100}
                onPress={() => {
                  handleCopyLink();
                }}
              >
                <Text
                  style={
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.SEMIBOLD_ANYBODY_10
                      : AppFontStyle.SEMIBOLD_ANYBODY_14
                  }
                >
                  Copy code
                </Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              paddingTop:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 10
                  : 22,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.MEDIUM_ANYBODY_12
                  : AppFontStyle.MEDIUM_ANYBODY_18,
                {},
              ]}
            >
              Send or share to your friends
            </Text>
            <Separator
              color={AppColors.white}
              height={1}
              marginTop={5}
              marginBottom={5}
              marginHorizontal={0}
            />
            <FlatList
              data={socialMediaOptions}
              numColumns={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 3
                  : 6
              }
              keyExtractor={(item) => item.id.toString()}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={{
                    padding: 12,
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginVertical: 5,
                    gap: 12,
                    marginHorizontal: 11,
                  }}
                  onPress={() => shareOnPlatform(item.name, item.link)}
                >
                  <Image
                    source={item.image}
                    style={{ height: 60, width: 60, resizeMode: "contain" }}
                  />
                  <Text style={AppFontStyle.MEDIUM_ANYBODY_12}>
                    {item.name}
                  </Text>
                </TouchableOpacity>
              )}
              columnWrapperStyle={{ justifyContent: "space-around" }}
            />
          </View>
          <Separator
            color={AppColors.white}
            height={1}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? AppFontStyle.MEDIUM_ANYBODY_10
                : AppFontStyle.MEDIUM_ANYBODY_18,
              {
                marginVertical:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 10
                    : 22,
                textAlign: "center",
              },
            ]}
          >
            You’ve referred {adjustedReferralCount}/5 users.{" "}
            {referralCount % 5 === 0 && referralCount > 0
              ? `Tokens are added to your wallet.`
              : `Refer ${5 - adjustedReferralCount} more for your next reward`}
          </Text>
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "50%"
                    : 327,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 6,
                }}
              >
                <Text
                  style={
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.MEDIUM_ANYBODY_12
                      : AppFontStyle.MEDIUM_ANYBODY_18
                  }
                >
                  {adjustedReferralCount}
                </Text>
                <Text
                  style={
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? AppFontStyle.MEDIUM_ANYBODY_12
                      : AppFontStyle.MEDIUM_ANYBODY_18
                  }
                >
                  5
                </Text>
              </View>
              <CustomProgressBar currentStep={adjustedReferralCount} />
            </View>
          </View>
        </View>
      </View>
      <ShowLoader showIndicater={loader} isBackGround={true} />
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      // height: "80%",
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      margin: 30,
      alignSelf: "center",
      borderRadius: 24,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
    textInputStyle: {
      paddingHorizontal: 12,
      paddingVertical: 10,
      color: AppColors.white,

      flex: 1,
      backgroundColor: AppColors.black,
      outlineStyle: "none",
      borderRadius: 8,
      borderWidth: 1,
      borderColor: AppColors.gray_5C5C5C,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "95%",
        padding: 12,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "95%",
        padding: 12,
      },
    },
  }
);
